import dateService from "../../../../../../common/utils/date/date.service";
import orderOptimizerTranslationsHelper from "../../../../../../languages/order-optimizer-translations.helper";
import { OrderOptimizerRailyListingItemStatus } from "../../common/types/order-optimizer-raily-listing-item";

const getDateLabel = (date: Date | null): string => {
  if (!date) {
    return "";
  }

  return dateService.formatDateTime(date);
};

const getScoreLabel = (score: number) => {
  const translations =
    orderOptimizerTranslationsHelper.getRailyListingTranslations().table;

  return `${translations.scoreLabel} ${score.toFixed() ?? "---"}`;
};

const getIdLabel = (id: number) => {
  const translations =
    orderOptimizerTranslationsHelper.getRailyListingTranslations().table;

  return `${translations.idLabel} ${id ?? "---"}`;
};

const getClassNameByStatus = (
  status: OrderOptimizerRailyListingItemStatus,
): string => {
  switch (status) {
    case OrderOptimizerRailyListingItemStatus.PENDING:
      return "pending";
    case OrderOptimizerRailyListingItemStatus.INTERESTING:
      return "interesting";
    case OrderOptimizerRailyListingItemStatus.REJECTED:
      return "rejected";
  }
};

const getStatusLabel = (
  status: OrderOptimizerRailyListingItemStatus,
): string => {
  const translations =
    orderOptimizerTranslationsHelper.getRailyListingTranslations().status;

  switch (status) {
    case OrderOptimizerRailyListingItemStatus.INTERESTING:
      return translations.interesting;
    case OrderOptimizerRailyListingItemStatus.PENDING:
      return translations.pending;
    case OrderOptimizerRailyListingItemStatus.REJECTED:
      return translations.rejected;
  }
};

const getDelayLabel = (delaySeconds: number): string => {
  const hours = Math.floor(delaySeconds / 3600);
  const minutes = Math.floor((delaySeconds % 3600) / 60);

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0",
  )} h`;
};

const getDelayTitle = (delaySeconds: number): string => {
  const translations =
    orderOptimizerTranslationsHelper.getRailyListingTranslations().table;

  return `${translations.orderDelayedLabel}: ${getDelayLabel(delaySeconds)}`;
};

const orderOptimizerRailyListingTableRowHelper = {
  getDateLabel,
  getDelayTitle,
  getDelayLabel,
  getScoreLabel,
  getIdLabel,
  getClassNameByStatus,
  getStatusLabel,
};

export default orderOptimizerRailyListingTableRowHelper;
